// extracted by mini-css-extract-plugin
export default {"ldsDualRing":"Loader_ldsDualRing__f9dTM"};